// Mock data for the Revera website

export const mockTeamData = [
  {
    name: 'Muhammed Sabri Cengiz',
    role: 'Endüstri Mühendisi',
    bio: 'Sistem optimizasyonu ve proje yönetimi konusunda uzman. Pasif radar sistemlerinin operasyonel verimlilik ve maliyet analizlerini yönetmektedir.',
    image: 'images/resim1.jpeg',
    linkedin: 'https://www.linkedin.com/in/muhammedsabricengiz/',
    email: 'sabri.cengiz@reverard.com'
  },
  {
    name: 'Enes Alperen Akkoca',
    role: 'Elektrik Elektronik Mühendisi',
    bio: 'RF devre tasarımı ve sinyal işleme alanında uzmanlaşmıştır. Pasif radar sistemlerinin donanım altyapısını geliştirmektedir.',
    image: 'images/resim2.jpeg',
    linkedin: 'https://www.linkedin.com/in/3eeaa/',
    email: 'enes.akkoca@reverard.com'
  },
  {
    name: 'Ömer Faruk Yılmaz',
    role: 'Bilgisayar Mühendisi',
    bio: 'Algoritma geliştirme ve yazılım mimarisi konusunda deneyimli. Sinyal işleme algoritmaları ve veri analizi sistemlerini tasarlamaktadır.',
    image: 'images/resim3.jpeg',
    linkedin: 'https://www.linkedin.com/in/omerr589',
    email: 'omer.yilmaz@reverard.com'
  },
  {
    name: 'Havva Nisa Canlı',
    role: 'Telekomünikasyon Mühendisi',
    bio: 'Kablosuz iletişim sistemleri ve frekans yönetimi alanında uzman. Çoklu sinyal kaynaklarının entegrasyonunu sağlamaktadır.',
    image: 'images/resim4.jpeg',
    linkedin: 'https://www.linkedin.com/in/havva-nisa-canli/',
    email: 'havvanisa.canli@reverard.com'
  }
];

